module.exports = __webpack_public_path__ + "img/vuelo6.db623952.jpg";